module.exports = __webpack_public_path__ + "static/media/castel.eccf203e.jpg";